import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem } from 'reactstrap';
import AdminMenu from './adminmenu';
import {firebase, googleAuth} from '../../firebase';


class MyMenu extends Component {

    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
          isOpen: false,
          isLogin: false
        };
      }

      login = (e) => {
        firebase.auth().signInWithPopup(googleAuth).then(()=>{
            this.setState({
                isLogin: true
            });
        });
      }

      logout = (e) => {
        firebase.auth().signOut();
        this.setState({
            isLogin:false
        });
      }

      toggle() {
        this.setState({
          isOpen: !this.state.isOpen
        });
      }

      componentDidMount = () =>{
          if(this.props.user){
              this.setState({
                  isLogin: true
              });
          }
      }

    render() {
        return (
            <div>
                <Navbar color="light" light expand="md">
                    <NavbarBrand tag={()=>{return (<Link to="/" style={{textDecoration:'none', color:'balck'}}>RoboShop</Link>)}}></NavbarBrand>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <Link to="/robots-list" style={{textDecoration:'none'}} className="nav-link">Robots</Link>
                            </NavItem>
                            <NavItem>
                                <Link to="/manufacturers-list" style={{textDecoration:'none'}} className="nav-link">Manufacturers</Link>
                            </NavItem>
                            <NavItem>
                                <Link to="/about-us" style={{textDecoration:'none'}} className="nav-link">About Us</Link>
                            </NavItem>
                            {this.props.user ? <AdminMenu /> : ''}
                            <NavItem>
                                {this.props.user || this.state.isLogin ?
                                <Link onClick={this.logout} to="" style={{textDecoration:'none'}} className="nav-link" >Logout</Link>
                                :
                                <Link onClick={this.login} to="" style={{textDecoration:'none'}} className="nav-link" >Login</Link>
                                }
                            </NavItem>                            
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>   
        );
    }
}

export default MyMenu;


// WEBPACK FOOTER //
// ./src/components/header/mymenu.js